import { type WorkflowStepUser } from "~/api/types";
import { useUserContext } from "~/hooks/useUserContext";
import AvatarWithFallback from "./AvatarWithFallback";
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from "~/atoms/tooltip";
import { useTranslation } from "react-i18next";
import { printFullName } from "~/helpers/user";
import { WorkflowStepBadge } from "./WorkflowStepBadge";
import { getWorkflowStepTooltip } from "~/helpers/workflow-instances";

interface Props {
  users: WorkflowStepUser[];
  isActive: boolean;
}

export function StepUsers({ users, isActive }: Props) {
  const { user } = useUserContext();
  const { t } = useTranslation();

  if (users.length === 0)
    return (
      <div className="text-muted-foreground text-xs italic">
        {t(($) => $.commons.workflow.noUsersAssigned)}
      </div>
    );

  return (
    <div className="flex flex-wrap gap-2">
      {users.map((u) => {
        const isCurrentUser = u.userId === user.id;

        const tooltip = getWorkflowStepTooltip(
          u.responseStatus,
          u,
          isCurrentUser,
          t,
        );

        return (
          <TooltipProvider key={u.userId}>
            <Tooltip>
              <TooltipTrigger className="cursor-help">
                <WorkflowStepBadge
                  response={u.responseStatus}
                  isActive={isActive}
                >
                  <AvatarWithFallback user={u} size="xs" />
                  <span className="font-normal">
                    {printFullName({ firstName: u.firstName }, isCurrentUser)}
                  </span>
                </WorkflowStepBadge>
              </TooltipTrigger>
              <TooltipContent>
                <p>{tooltip}</p>
              </TooltipContent>
            </Tooltip>
          </TooltipProvider>
        );
      })}
    </div>
  );
}
